import React from 'react';
import { ArticleCard } from './ArticleCard';
import { PlusButton } from './PlusButton';
export function SpecialReport() {
  return <section className="w-full relative" style={{
    marginTop: '37px'
  }} data-id="element-284">
      {/* INSIGHTS badge */}
      <div className="flex justify-center relative z-10" data-id="element-285">
        <div className="has-radius bg-white inline-flex items-center justify-center" style={{
        padding: '8px 24px',
        borderRadius: '18px',
        height: '33px'
      }} data-id="element-286">
          <span style={{
          color: '#090909',
          textAlign: 'center',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '1.125rem',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
          textTransform: 'uppercase' as const
        }} data-id="element-287">
            Insights
          </span>
        </div>
      </div>

      {/* Background image area */}
      <div className="relative w-full md:h-[472px]" style={{
      marginTop: '-16px',
      paddingBottom: '40px'
    }} data-id="element-288">
        {/* Background image */}
        <img src="https://cdn.magicpatterns.com/uploads/wzThEQAKYAAkwne4hcdEap/Rectangle_87_(1).png" alt="" className="absolute inset-0 w-full h-full object-cover" style={{
        zIndex: 0
      }} data-id="element-289" />

        {/* Dark overlay */}
        <div className="absolute inset-0" style={{
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: 1
      }} data-id="element-290" />

        {/* Text content */}
        <div className="relative site-container flex flex-col items-center" style={{
        zIndex: 2,
        paddingTop: '90px'
      }} data-id="element-291">
          {/* SPECIAL REPORT label */}
          <span style={{
          color: '#FFF',
          textAlign: 'left',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '18.75px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          letterSpacing: '1.875px',
          textTransform: 'uppercase' as const
        }} data-id="element-292">
            Special Report
          </span>

          {/* Title */}
          <h2 style={{
          color: '#FFF',
          fontFamily: "'League Gothic', Impact, Arial, sans-serif",
          fontSize: '65px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '65px',
          textAlign: 'left',
          marginTop: '16px',
          maxWidth: '800px'
        }} data-id="element-293">
            The US agencies storming up the World Creative Rankings
          </h2>

          {/* Description */}
          <p style={{
          color: '#FFF',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          textAlign: 'left',
          marginTop: '16px',
          maxWidth: '700px'
        }} data-id="element-294">
            Special Group, a global independent creative network, was the year's
            biggest climber in North America.
          </p>
        </div>
      </div>

      {/* Article cards — overlapping the background */}
      <div className="relative site-container mt-6 md:-mt-[120px]" style={{
      zIndex: 3
    }} data-id="element-295">
        <div className="relative" style={{
        maxWidth: '1040px',
        margin: '0 auto'
      }} data-id="element-296">
          <div className="w-full grid grid-cols-1 md:grid-cols-3" style={{
          gap: '37px'
        }} data-id="element-297">
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/hmd8RTg2dhqgufNWoSEJMx/Rectangle_41.png" title="Mazda and Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-298" />
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/fyT1wVaYT9WKKJQgDtrP5M/Rectangle_42.png" title="Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-299" />
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/iFm4zkS1U82HqEHJNgBYw2/Rectangle_52.png" title="Dubai Culture launches Ramadan-themed animated series 'Badr Al Musahar'" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-300" />
          </div>
          <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-301">
            <PlusButton size="sm" data-id="element-302" />
          </div>
        </div>
      </div>
    </section>;
}